const sessionStorageKey = "slugs";

// This solution uses session storage because short-lived persisted statement navigation
// is good enough. Session storage persists data on browser tab or window level and is
// cleared as soon as the tab or window is closed.

export function initStatementNavigation(statementSlugs: string[]) {
  // Create a (kind of) linked list of all slugs.
  // It's an object with the slug as property and the next slug as value.
  const linkedList: { [index: string]: any } = {};
  let prev = null;
  for (let index = 0; index < statementSlugs.length; index++) {
    // Add a new slug to the list, which has no prev and next slug yet.
    const currentSlug = statementSlugs[index];
    linkedList[currentSlug] = { next: null, prev: null };

    // If there is a previous slug, the curent becomes the next for that previous slug.
    // And for the current slug, that previous one becomes the previous slug.
    if (prev) {
      linkedList[currentSlug].prev = prev;
      linkedList[prev].next = currentSlug;
    }

    // Remember the current slug as the previous for the next iteration.
    prev = currentSlug;
  }

  sessionStorage.setItem(sessionStorageKey, JSON.stringify(linkedList));
}

export function getPrev(currentSlug: string) {
  const statementSlugs = getStatementSlugs();
  if (
    !currentSlug ||
    currentSlug.length === 0 ||
    statementSlugs.length === 0 ||
    !(currentSlug in statementSlugs)
  )
    return null;
  return statementSlugs[currentSlug].prev;
}

export function getNext(currentSlug: string) {
  const statementSlugs = getStatementSlugs();
  if (
    !currentSlug ||
    currentSlug.length === 0 ||
    statementSlugs.length === 0 ||
    !(currentSlug in statementSlugs)
  )
    return null;
  return statementSlugs[currentSlug].next;
}

function getStatementSlugs() {
  return JSON.parse(sessionStorage.getItem(sessionStorageKey) || "{}") || [];
}
